import { TBColumn } from "../../../interfaces/TableBits.interfaces";
const columns: TBColumn[] = [
  {
    id: "bussinesName",
    label: "Nombre",
    align: "left",
  },
  {
    id: "nameEnterprise",
    label: "Empresa",
    align: "left",
  },
  {
    id: "puesto",
    label: "Puesto",
    align: "left",
  },
  {
    id: "campus",
    label: "Sede",
    align: "left",
  },
  {
    id: "project",
    label: "Proyecto/Área",
    align: "left",
  },
  {
    id: "dateOfAdmission",
    label: "Fecha de ingreso",
    align: "left",
  },
  {
    id: "terminatedCourses",
    label: "Cursos terminados",
    align: "left",
  },
  {
    id: "inProgressCourses",
    label: "Cursos en progreso",
    align: "left",
  },
];

export default columns;
